import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
    Box,
    Button,
    Flex,
    Grid,
    GridItem,
    Icon,
    Image,
    Separator,
    Stack,
    Text,
} from "@chakra-ui/react";
import { CaretRightIcon, CaretUpIcon } from "@phosphor-icons/react/dist/ssr";
import { useState } from "react";

const Amenities = ({ dataDevelopment }) => {
    const [showAll, setShowAll] = useState(false);

    // Combinar amenities y customAmenities en un solo array
    const amenities = [
        ...(dataDevelopment?.amenities || []),
        ...(dataDevelopment?.customAmenities || []),
    ];

    // Definir cuántos mostrar antes de "Ver más"
    const visibleAmenities = showAll ? amenities : amenities.slice(0, 6);

    const cleanAmenity = (amenity) => {
        // Reemplazar espacios por guiones
        const amenityWithoutSpaces = amenity.replace(/\s+/g, "-");
        // Reemplazar '/' por guiones
        const amenityWithoutSlashes = amenityWithoutSpaces.replace(/\//g, "-");
        // Eliminar los acentos y convertir todo a minúsculas
        const amenityWithoutAccents = amenityWithoutSlashes
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        // Reemplazar 'ñ' y 'Ñ' por 'n'
        const amenityWithoutSpecialChars = amenityWithoutAccents.replace(/[ñÑ]/g, "n");

        return amenityWithoutSpecialChars.toLowerCase(); // Todo a minúsculas
    };

    return (
        <>
            <Grid
                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(1, 1fr)" }}
                gap={6}
                h="min-content"
            >
                <GridItem colSpan={1}>
                    <Stack h="100%">
                        <Box bg="white" rounded="md" h="100%">
                            <Text
                                fontWeight={700}
                                fontSize="md"
                                textAlign={{ base: "center", md: "initial" }}
                                my={4}
                            >
                                Amenidades
                            </Text>
                            <Grid
                                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
                                gap={2}
                                mt={2}
                            >
                                {visibleAmenities?.map((amenity, index) => {
                                    return (
                                        <GridItem key={index}>
                                            <Flex
                                                maxW={{ base: "100%", md: "80%" }}
                                                borderWidth={1}
                                                borderColor="#C4C4C4"
                                                borderRadius="md"
                                                p={2}
                                                gap={4}
                                                alignItems="center"
                                                h="100%"
                                            >
                                                <Image
                                                    alt="icon"
                                                    src={`https://media.grupoguia.mx/vision/icon/amenitiesIcons/${cleanAmenity(amenity)}.svg`}
                                                    h="20px"
                                                    w="20px"
                                                    onError={(e) =>
                                                        (e.target.src =
                                                            "https://media.grupoguia.mx/vision/icon/amenitiesIcons/terraza.svg")
                                                    }
                                                />

                                                <Text fontWeight={400} fontSize="sm">
                                                    {amenity}
                                                </Text>
                                            </Flex>
                                        </GridItem>
                                    );
                                })}
                            </Grid>
                            <Grid templateColumns="repeat(1, 1fr)" gap={2} mt={2}>
                                <GridItem>
                                    <Flex justifyContent="center">
                                        {amenities.length > 6 && ( // Mostrar el botón solo si hay más de 8 elementos
                                            <Button
                                                fontWeight="regular"
                                                size="md"
                                                bg="white"
                                                color="blue.500"
                                                border="2px solid"
                                                borderColor="blue.500"
                                                _hover={{
                                                    bg: "blue.500",
                                                    color: "white",
                                                    borderColor: "blue.500",
                                                    "& .chakra-icon": {
                                                        color: "white",
                                                    },
                                                }}
                                                mt={5}
                                                px={4}
                                                fontSize={{ base: "sm", md: "sm" }}
                                                onClick={() => setShowAll(!showAll)}
                                                rounded="sm"
                                            >
                                                {showAll ? "Ver menos" : "Ver más"}
                                                {!showAll ? (
                                                    <Icon boxSize={4} color="blue.500">
                                                        <CaretRightIcon weight="bold" />
                                                    </Icon>
                                                ) : (
                                                    <Icon boxSize={4} color="blue.500">
                                                        <CaretUpIcon weight="bold" />
                                                    </Icon>
                                                )}
                                            </Button>
                                        )}
                                    </Flex>
                                </GridItem>
                            </Grid>
                        </Box>
                    </Stack>
                </GridItem>
            </Grid>
            <Box>
                <Separator borderColor="#B1B1B1" mt={7} />
            </Box>
        </>
    );
};

export default Amenities;
